<div class="card card-primary m-3">
    <div class="card-header mx-auto d-flex justify-content-center" style="width: 100%;">
        <h3 class="card-title">Agent Bank Profile</h3>
    </div>

    <div class="card-body">
        <div class="row flex-column-reverse flex-md-row">
            <div class="col-sm-7 col-md-7">
                <div class="row mt-3">
                    <div class="col-sm-2 col-md-2"></div>
                    <div class="col-sm-3 col-md-3">
                        <label>ชื่อ-นามสกุล</label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <input type="text" id="txtName" class="form-control" readonly>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-2 col-md-2"></div>
                    <div class="col-sm-3 col-md-3">
                        <label>เบอร์โทรศัพท์</label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <input type="text" id="txtPhoneNo" class="form-control" readonly>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-2 col-md-2"></div>
                    <div class="col-sm-3 col-md-3">
                        <label>หน่วยงาน</label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <input type="text" id="txtTeam" class="form-control" readonly>
                    </div>
                </div>
            </div>
            <div class="text-center col-sm-5 col-md-5">
                <div class="row">
                    <div class="col-sm-12 col-md-12 text-center">
                        <button id="btnChangePwd" class="btn btn-changepwd" (click)="ChangePassword()">
              Change Password
              <img src="../../assets/images/changepassword.png">
            </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 text-center">
                        <img src="../../assets/images/user.png" class="border-solid" style="width: 15vw;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="modal fade" id="dlgChngPwd" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" id="btnCloseDlg" data-dismiss="modal">X</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12" style="display: flex; justify-content: center;">
                            <h3>เปลี่ยนรหัสผ่านใหม่</h3>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-4">รหัสผ่านปัจจุบัน</div>
                        <div class="col-8"><input type="password" id="txtCurrPwd" class="form-control"></div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-4">รหัสผ่านใหม่</div>
                        <div class="col-8"><input type="password" id="txtNewPwd" class="form-control"></div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-4">ยืนยันรหัสผ่าน</div>
                        <div class="col-8">
                            <input type="password" id="txtConfirmPwd" class="form-control">
                            <span style="color: red;" id="lblPwdError"></span>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-12">1. ตั้งรหัสผ่านใหม่ เป็นภาษาอังกฤษความยาว 8 ถึง 16 ตัวอักษร</div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-12">2. โดยจะต้องมีอักษรตัวใหญ่ (A-Z) และตัวเล็ก (a-z)
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-12">3. ตัวเลข (0-9) และอักขระพิเศษ (!,@,...) ผสมกัน
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-12" style="display: flex; justify-content: center;">
                            <button class="btn btn-success" (click)="SavePassword()">บันทึก</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/profile/profile.component.html